module.exports = __webpack_public_path__ + "static/media/mall_logo_bottom.831c8224.png";